import React from 'react';

import LottieView from 'lottie-react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

export const ResetLocationAnimation = ({ onComplete }: { onComplete?: () => void }) => {
  const uri = useStaticLottieUri(StaticImages.DotLoader);
  const { source } = useLottieSource({
    source: uri ? { uri } : undefined,
    surface: 'reset_location',
  });

  if (!source) {
    return null;
  }

  return (
    <LottieView
      testID="reset-location-loading-animation"
      source={source}
      autoPlay
      loop={false}
      onAnimationFinish={() => onComplete?.()}
      style={{ width: 50, height: 50 }}
    />
  );
};
